import userListReducer from "../../slices/user_management/user/UserList"
import userDetailsReducer from "../../slices/user_management/user/UserDetails"
import qrCodeByAssetReducer from "../../slices/assets/qr_code/QRCodeByAsset"


const userManagementReducer = {
    userList: userListReducer,
    userDetails: userDetailsReducer,
    qrCodeByAsset: qrCodeByAssetReducer,

}

export default userManagementReducer

